/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';
import { TAB_GAP, TAB_HEIGHT } from '@atlassian/navigation-kit-common';

const TabWrapper = forwardRef<HTMLDivElement | HTMLUListElement, React.PropsWithChildren<object>>(
	({ children }, ref) => {
		if (fg('jfp_a11y_team_board_missing_unordered_list_mark-up')) {
			return (
				<ul css={[styles.root, listStyles.ulRoot]} ref={ref as React.Ref<HTMLUListElement>}>
					{children}
				</ul>
			);
		}

		return (
			<div css={[styles.root]} ref={ref as React.Ref<HTMLDivElement>}>
				{children}
			</div>
		);
	},
);

const styles = cssMap({
	root: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${TAB_HEIGHT}px`,
		marginBottom: token('space.0'),
		marginLeft: token('space.negative.150'),
		marginRight: token('space.negative.150'),
		marginTop: token('space.0'),
		overflow: 'hidden',
		paddingBottom: token('space.0'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		paddingTop: token('space.0'),
	},
});

const listStyles = cssMap({
	ulRoot: {
		listStyleType: 'none',
	},
});

export default TabWrapper;
